
namespace Ir.Components.ReportDesigner.ComparisonFilterFilters {

    interface IViewModel {
        comparisonFilter: KnockoutObservable<ComparisonFilter>;
        filterSection: Ir.Components.Filters.FilterSection.IFilterSectionParams;
        scrollViewOptions: DevExpress.ui.dxScrollView.Properties;
    }

    export interface IParams {
        comparisonFilter: KnockoutObservable<ComparisonFilter>;
    }

    let popoverComponent: DevExpress.ui.dxPopover = null;
    let koComparisonFilter: KnockoutObservable<ComparisonFilter> = ko.observable(null);
    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        this.comparisonFilter = params.comparisonFilter;

        this.filterSection = {
            scope: ko.computed(function () {
                return ContainerScopeEnum.ComparisonFilter;
            }),
            filters: ko.computed(function () {
                return self.comparisonFilter().filters;
            }),
            isToolbar: false,
            title: ko.computed(function () {
                return "Filters";
            }),
            icon: "filter_alt"
        };
        this.scrollViewOptions = {
            direction: "vertical",
            useNative: false
        };
    }

    export function show(comparisonFilter: ComparisonFilter, $target: JQuery<HTMLElement>) {

        koComparisonFilter(comparisonFilter);
        if (popoverComponent) {
            popoverComponent.show($target);
        }
        else {
            let popoverOptions = {
                position: "right",
                showTitle: false,
                title: "Filters",
                width: 300,
                maxHeight: "95%",
                onInitialized(e) {
                    popoverComponent = e.component;
                    popoverComponent.show($target);
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopover: popoverOptions">
                <comparison-filter-filters params="comparisonFilter: comparisonFilter"></comparison-filter-filters>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popoverOptions, comparisonFilter: koComparisonFilter }, $popover[0]);
        }
    }
    export function hide() {
        if (popoverComponent) {
            popoverComponent.hide();
        }
    }
}